import { render, staticRenderFns } from "./display.vue?vue&type=template&id=3a363980&"
import script from "./display.vue?vue&type=script&lang=js&"
export * from "./display.vue?vue&type=script&lang=js&"
import style0 from "./display.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports